// import registerServiceWorker from './registerServiceWorker';
import $ from 'jquery';
import './css/main.css';
import 'font-awesome/css/font-awesome.css'
import './Scripts/Spreadsheet/spreadsheet.css'
global.jQuery = $
require('./App/MainClient/index.jsx')


function watchHistoryEvents() {
    const { pushState, replaceState } = window.history;

    window.history.pushState = function (...args) {
        pushState.apply(window.history, args);
        window.dispatchEvent(new Event('pushState'));
    };

    window.history.replaceState = function (...args) {
        replaceState.apply(window.history, args);
        window.dispatchEvent(new Event('replaceState'));
    };

    window.addEventListener('popstate', () => {
        console.log('pop');
        localStorage.setItem('lastLocation', window.location.href)
    });
    window.addEventListener('replaceState', () => {
        console.log('replace')
        localStorage.setItem('lastLocation', window.location.href)
    }
    );
    window.addEventListener('pushState', (e) => {
        console.log('push')
        localStorage.setItem('lastLocation', window.location.href)
    });
}
watchHistoryEvents();
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js